import { Checkbox, Form, Icon, Input, Select } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import './style.css';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { IFormDetails } from '../../../../app/stores/dashboardConfiguration/types';
import agent from '../../../../app/api/agent';
import { formMasterElementType } from './type';

function FormConf() {
  const { DashboardConfigurationStore } = useStore();
  const [selectedMetaData, setSelectedMetaData] = useState<
    { elementName: string; elementType: string }[]
  >([]);
  const [metaDataList, setMetaDataList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [basedOnOptions, setBasedOnOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  const dependencyMaster = useRef<string>('');

  const { form, GETMasterMetaData } = DashboardConfigurationStore;

  const getParsedMasterElement = () => {
    return JSON.parse(form?.masterElement || '[]');
  };

  const saveMasterElement = (tempMasterElement: formMasterElementType[]) => {
    DashboardConfigurationStore.form = {
      ...DashboardConfigurationStore.form,
      masterElement: JSON.stringify(tempMasterElement),
    };
  };

  useEffect(() => {
    let tempMasterElement =
      form?.masterElement !== undefined ? getParsedMasterElement() : [];
    let tempMetaDataValue: { elementName: string; elementType: string }[] = [];
    let tempMetaDataList: { key: string; text: string; value: string }[] = [];
    let collectMetadataIDs: string[] = [];
    form.metaData?.forEach((data: IFormDetails) => {
      tempMasterElement?.forEach((selectedData: formMasterElementType) => {
        if (
          selectedData?.elementId === data.elementId &&
          selectedData?.mode !== 2 &&
          selectedData?.mode !== undefined
        ) {
          tempMetaDataValue?.push({
            elementName: data.elementName,
            elementType: data.elementType,
          });
        }
      });
      tempMetaDataList?.push({
        key: data.elementId,
        text: data.elementName,
        value: data.elementName,
      });
      collectMetadataIDs?.push(data.elementId);
    });
    setMetaDataList(tempMetaDataList);
    setSelectedMetaData(tempMetaDataValue);

    const updateMasterElement: any[] = [];
    tempMasterElement?.forEach((data: any) => {
      if (collectMetadataIDs?.includes(data.elementId)) {
        updateMasterElement?.push(data);
      }
    });

    saveMasterElement(updateMasterElement);

    // eslint-disable-next-line
  }, [form?.metaData]);

  const setFormMetaData = (_event: any, data: any) => {
    let tempMetaData: { elementName: string; elementType: string }[] = [];
    const tempMasterElementGroup = JSON.parse(
      DashboardConfigurationStore.form.masterElement,
    );
    const dataValuesSet = new Set(data.value);
    const tempMasterElementMap: any = {};

    form.metaData?.forEach((tempData) => {
      const { elementId, elementName, elementType, elementValue } = tempData;
      if (data.value?.includes(tempData.elementName)) {
        tempMetaData?.push({
          elementName: tempData.elementName,
          elementType: tempData.elementType,
        });
      }
      if (!dataValuesSet.has(elementName)) {
        tempMasterElementMap[elementId] = {
          elementId,
          elementName,
          elementType,
          elementValue,
          mode: 2,
        };
      } else {
        // If the element is in data.value, find the corresponding mode from tempMasterElementGroup
        const group = tempMasterElementGroup.find(
          (item: any) => item.elementName === elementName,
        );
        if (group) {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: group.mode === 0 ? 0 : 1,
            dependency: group.dependency,
            criteria: group.criteria,
          };
        } else {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: 1,
          };
        }
      }
    });

    const uniqueData = Object.values(tempMasterElementMap);
    setSelectedMetaData(tempMetaData);
    saveMasterElement(uniqueData as formMasterElementType[]);
  };

  const switchMode = (data: IFormDetails) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: formMasterElementType) => {
      if (tempData.elementId === data.elementId) {
        tempData.mode = data.mode === 1 ? 0 : 1;
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const handleMasterChange = async (_e: any, data: any) => {
    let tempMetaDataList: IFormDetails[] = [];
    let masterKey: string = '';
    form.data?.forEach(async (master) => {
      if (master.value === data.value) {
        masterKey = master.key;
        return;
      }
    });
    if (masterKey !== '') {
      tempMetaDataList = await GETMasterMetaData(masterKey);
    }
    DashboardConfigurationStore.form = {
      ...DashboardConfigurationStore.form,
      masterName: data.value,
      metaData: tempMetaDataList?.filter(
        (met) => met.isActive && !met.isDeleted,
      ),
      masterElement: masterKey === '' ? '[]' : form.masterElement,
    };
  };

  const handleDependency = async (id: any, name: string, value: string) => {
    let result = await agent.dynamicMaster.getMasterDetailsAPI();
    let masterKey = '';
    const masterName = value?.split('|')?.[0];
    dependencyMaster.current = name;
    if (result?.data) {
      result?.data?.forEach((masters: any) => {
        if (masters.title === masterName) {
          masterKey = masters.masterId;
          return;
        }
      });
    }
    let tempMetaDataList: IFormDetails[] = [];
    if (masterKey !== '') {
      tempMetaDataList = await GETMasterMetaData(masterKey);
    }
    let tempCheckWithOptions: any = tempMetaDataList?.map((data) => {
      return {
        key: data.elementId,
        value: data.elementName,
        text: data.elementName,
      };
    });

    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: formMasterElementType) => {
      if (tempData.elementId === id) {
        tempData.dependency = {
          basedOn: '',
          checkWithOptions: tempCheckWithOptions,
          checkWith: '',
        };
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const removeDependency = (id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        delete tempData.dependency;
      }
    });
    saveMasterElement(tempMasterElement);
  };

  useEffect(() => {
    const tempBasedOnOptions: { key: string; text: string; value: string }[] =
      [];
    selectedMetaData?.forEach(
      (opt: { elementName: string; elementType: string }) => {
        if (
          dependencyMaster.current !== opt.elementName &&
          opt.elementType === 'Masters'
        ) {
          tempBasedOnOptions?.push({
            key: opt.elementName,
            text: opt.elementName,
            value: opt.elementName,
          });
        }
      },
    );
    setBasedOnOptions(tempBasedOnOptions);
    // eslint-disable-next-line
  }, [selectedMetaData, dependencyMaster.current]);

  const setBasedOn = (_event: any, data: any, id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: formMasterElementType) => {
      if (tempData.elementId === id) {
        tempData.dependency = {
          basedOn: data.value,
          checkWithOptions: tempData.dependency?.checkWithOptions || [],
          checkWith: tempData.dependency?.checkWith || '',
        };
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const setCheckWith = (_event: any, data: any, id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.dependency) {
          tempData.dependency = {
            basedOn: tempData.dependency.basedOn,
            checkWithOptions: tempData.dependency.checkWithOptions,
            checkWith: data.value,
          };
        }
      }
    });
    saveMasterElement(tempMasterElement);
  };

  return (
    <>
      <Form className="dashboardConfigIconWrapper">
        <Form.Field
          label={'Select Master'}
          control={Select}
          placeholder={'Select Master'}
          clearable
          fluid
          search
          selection
          options={form.data || []}
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={form?.masterName || ''}
          onChange={(_e: any, data: any) => handleMasterChange(_e, data)}
        />
        {form?.masterName !== 'Items' && (
          <>
            <Form.Field
              label={'Select Metadata'}
              control={Select}
              placeholder={'Select Metadata'}
              clearable
              fluid
              search
              selection
              multiple
              options={metaDataList || []}
              onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
                if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                  e.stopPropagation();
              }}
              style={{ marginTop: '5px' }}
              upward
              value={selectedMetaData.map((s) => s.elementName) || []}
              onChange={(_e: any, data: any) => setFormMetaData(_e, data)}
            />
          </>
        )}
      </Form>
      <div className="dashboardConfigMetadataSelection">
        {form?.masterElement !== '[]' &&
          form?.masterElement !== undefined &&
          getParsedMasterElement()?.map((data: IFormDetails) => {
            return (
              <>
                {data.mode !== 2 && data.mode !== undefined && (
                  <div>
                    <Form.Field
                      control={Input}
                      value={data.elementName}
                      readOnly
                    />
                    <span>
                      <span className="disable-checkbox">
                        <Checkbox
                          name="isDisabled"
                          onClick={(_e: SyntheticEvent) => {
                            switchMode(data);
                          }}
                          label="Disable"
                          checked={data.mode !== 1}
                        />
                      </span>
                    </span>
                    {/* {data.elementType === 'Masters' && ( */}
                    <span
                      className="form-set-dependency"
                      onClick={() =>
                        handleDependency(
                          data.elementId,
                          data.elementName,
                          data.elementValue,
                        )
                      }
                    >
                      Set dependency
                    </span>

                    {data.dependency !== undefined && (
                      <div className="show-dependency">
                        <label>Based on</label>
                        <Select
                          placeholder="Based on"
                          options={basedOnOptions}
                          value={data.dependency?.basedOn}
                          onChange={(_e: any, basedOnData: any) =>
                            setBasedOn(_e, basedOnData, data.elementId)
                          }
                        />
                        {data.elementType === 'Masters' &&
                          data.elementValue !== 'Items' && (
                            <>
                              <label>Check with</label>
                              <Select
                                placeholder="Check with"
                                options={
                                  data.dependency?.checkWithOptions || []
                                }
                                value={data.dependency?.checkWith}
                                onChange={(_e: any, checkWithData: any) =>
                                  setCheckWith(
                                    _e,
                                    checkWithData,
                                    data.elementId,
                                  )
                                }
                              />
                            </>
                          )}
                        <Icon
                          name="close"
                          onClick={() => removeDependency(data.elementId)}
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            );
          })}
      </div>
      <div className="pdf-download">
        <Checkbox
          name="isPDF"
          label="Automatic PDF Download after Form Save"
          onClick={(_e: SyntheticEvent, data: any) => {
            DashboardConfigurationStore.form = {
              ...DashboardConfigurationStore.form,
              automaticPdf: data.checked,
            };
          }}
          checked={DashboardConfigurationStore.form.automaticPdf}
        />
      </div>
    </>
  );
}

export default FormConf;
